import c1 from '../assets/catalogs/Communication Cables Brochure and plastics.pdf';
import c2 from '../assets/catalogs/Low Voltage.pdf';
import c3 from '../assets/catalogs/Meduim and High voltage.pdf';
import c4 from '../assets/catalogs/Overhead.pdf';


export const catalogs = [
  {
    id: 1,
    title: 'Communication Cables Brochure and plastics',
    file: c1,
  },
  {
    id: 2,
    title: 'Low Voltage',
    file: c2,
  },
  {
    id: 3,
    title: 'Medium and High Voltage',
    file: c3,
  },
  {
    id: 4,
    title: 'Overhead',
    file: c4,
  }
];

